import { Button } from "components";
import {
    AlertDialog,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type CancelOrderDialogProps = {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    isLoading?: boolean;
};

export default function CancelOrderDialog({
    isOpen,
    onOpenChange,
    onConfirm,
    isLoading = false,
}: CancelOrderDialogProps) {
    return (
        <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
            <AlertDialogContent className="max-w-sm rounded-lg">
                <AlertDialogHeader>
                    <AlertDialogTitle className="text-lg text-left font-semibold">
                        Cancel Order
                    </AlertDialogTitle>
                    <div className="border-b border-gray-300 mt-3" />
                    <AlertDialogDescription className="text-sm text-left mt-4 text-muted-foreground">
                        Are you sure you want to <span className="font-medium">cancel the order?</span>
                    </AlertDialogDescription>
                </AlertDialogHeader>

                <AlertDialogFooter className="flex flex-row justify-end gap-2 mt-4">
                    <AlertDialogCancel className="p-0 mt-0" disabled={isLoading}>
                        <Button
                            className="border border-[#165FE3] text-[#165FE3] bg-white  disabled:text-gray-200 px-4 py-2 rounded-[8px] w-32"
                        >
                            Cancel
                        </Button>
                    </AlertDialogCancel>

                    <button
                        onClick={onConfirm}
                        disabled={isLoading}
                        className="border border-gray-300 text-[#ffffff] bg-blue-600 disabled:bg-blue-400 disabled:text-gray-200 px-4 rounded-[8px] w-32"
                    >
                        {isLoading ? "Processing..." : "Confirm"}
                    </button>
                </AlertDialogFooter>

            </AlertDialogContent>
        </AlertDialog>
    );
}
